export default __webpack_public_path__ + "static/media/menuOfTheWeek.52215533.png";